import styles from "@/styles/layout/Header.module.css";
import Image from "next/image";

interface HeaderProps {
  logo: string;
}

export default function Header({ logo }: HeaderProps) {

  return (
    <header>
      <nav className={styles.navbar} aria-label="Barra superior">
          <Image
            width={100}
            height={80}
            className={styles.logoImage}
            src={logo}
            alt="Logo del Proyecto"
          />
      </nav>
    </header>
  );
}